import React, { useState, useEffect, useRef } from "react";
import { Audio_SAMPLE_RATE, get_audio_worklet_processor_module } from "./audio_utils";
import { WavRecorder } from "wavtools";
import { FaMicrophone, FaMicrophoneAlt, FaMicrophoneAltSlash } from "react-icons/fa";

/** 
 * It uses WavTools to take in input audio which is used by OpenAI team for demo's
 * https://github.com/keithwhor/wavtools/tree/main
 * UI component for recording and stop recording audio
 * records audio data and send through callback to parent components
 * - it transmits audio chunk size of 2048 at a time
 * - which is the Best balance for OpenAI real-time streaming
 * - latency is good with 2048 and it is skipping fewer words
 * - larger chunk sizes are slow and feel less accurate.
 */
const AudioRecorderWavRecorder = ({selectedMicrophone, audioDataCallback }) => {
  const [audioChunks, setAudioChunks] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const wavRecorderRef = useRef(null);  
  // open ai api's need 24 GHZ, pcm 16, mono or 1 channel audio
  const SAMPLE_RATE = Audio_SAMPLE_RATE;
  //const wavRecorder=new WavRecorder({sampleRate:SAMPLE_RATE}) 

  // Fetch available microphones
  useEffect(() => {
    wavRecorderRef.current = new WavRecorder({sampleRate:SAMPLE_RATE}) 
  }, []);

  const startRecording = async () => {
    try {
     if(wavRecorderRef.current!=null) await stopRecording()
     setIsRecording(true)
     try{ // may be create a new object each time
      wavRecorderRef.current = new WavRecorder({sampleRate:SAMPLE_RATE}) 
      await wavRecorderRef.current.begin(selectedMicrophone.deviceId)
    } catch (error) {
      console.log("error while intitializing and begining recording ")
      console.log( error);
    }
    // console.log('Recording started by wav recorder. '+isRecording+" recording status "+wavRecorderRef.current.getStatus()+" device id "+selectedMicrophone.deviceId); 

     wavRecorderRef.current.record((data)=>{
       // console.log('is wav recorder recording ? '+isRecording+" recording status "+wavRecorderRef.current.getStatus()); 
    try{  
        if( data && data.mono ){
          audioDataCallback(data.mono) 
        }
    } catch (error) {
      console.log("error while recording")
      console.log( error);
    }
     }, 16384 ) // 2048 Best balance for OpenAI real-time streaming
     // i am using 16384 for DeepGram and it works amazing 
     // switched to 8192 becuase 16384 was giving out of memory error
     
    } catch (error) {
      console.log('Error starting recording:', error);
    }
  };

  const stopRecording = async() => {
    try {
        setIsRecording(false) 
        try{ 
        await wavRecorderRef.current.pause() 
        }catch(error){console.log(error)} 
        await wavRecorderRef.current.end()   
        wavRecorderRef.current = null 
     
      console.log('wav recorder Recording paused.');
    } catch (error) {
      wavRecorderRef.current = null 
      console.log('Error stopping recording:', error);
    }
  };

  
  return (
    <div className=" mx-auto  shadow-md rounded-lg">
      
      {/* Control Buttons */}
      <div className="flex flex-row space-x-4">
       { !isRecording && 
       <button
          className=" flex flex-row items-center justify-center
           px-10 py-6 bg-purple-500 text-white rounded-lg shadow-md hover:bg-purple-600 focus:outline-none"
          onClick={startRecording}
          disabled={isRecording}
        >
         <FaMicrophoneAlt className="text-3xl" />   &nbsp; &nbsp;
         <span> Start Speaking </span>
        </button>
      }
      { isRecording &&
        <button
          className="flex flex-row items-center justify-center
          px-10 py-6 bg-red-500 text-white rounded-lg shadow-md hover:bg-red-600 focus:outline-none"
          onClick={stopRecording}
          disabled={!isRecording}
        >
            <FaMicrophoneAltSlash className="text-4xl " />  &nbsp;  &nbsp;
         <span>  Mute Microphone </span>
        </button>
       
      }
      </div>

      {/* Audio Chunks Info */}
      { false &&
      <div className=" p-2 text-center text-sm">
        <p className="text-gray-700">
          {isRecording ? "Recording..." : `Captured Chunks: ${audioChunks.length}`}
          <br />
         
        </p>
      </div>
      }
    </div>
  );
};

export default AudioRecorderWavRecorder;
